import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '../base.service';
import { MessageService } from '../message.service';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class UserSearchSettingService extends BaseService {

  private wsBase: string =  "/usersearchsetting/";

  constructor(http: HttpClient, messageService:MessageService) {
    super(http, messageService);
  }

  loadPage(page: number, pageSize:number, queryString:string):Observable<any> {
    var url = this.wsUrl(this.wsBase) + "list?"+"page="+page+"&pageSize="+pageSize+"&q="+queryString;
    return this.dataGET(url);
  }

  loadById(id: number):Observable<any> {
    var url = this.wsUrl(this.wsBase) + "details/"+id;
    return this.dataGET(url);
  }

  save(model:any):Observable<any> 
  {
    var url = this.wsUrl(this.wsBase)+"details";
    return this.dataPOST(url, JSON.stringify(model));
  }

  delete(model:any):Observable<any> 
  {
    var url = this.wsUrl(this.wsBase)+"delete";
    return this.dataPOST(url, JSON.stringify(model));
  }
  
}
